import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Michigan State Portal": {
    parameters: {
      linkUrls: ["https://egle-hazconnect.michigan.gov/Account/Login.aspx"],
      staffInputs: {
        documentTypes: {
          report: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "MI",
  },
};
